import { render, staticRenderFns } from "./InputDataImport.vue?vue&type=template&id=b841a324"
import script from "./InputDataImport.vue?vue&type=script&lang=js"
export * from "./InputDataImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports